var map = {
	".": 8305,
	"./": 8305,
	"./App": 505,
	"./App.css": 3508,
	"./App.js": 505,
	"./App.test": 754,
	"./App.test.js": 754,
	"./List": 2581,
	"./List.js": 2581,
	"./img/DC004.jpg": 4918,
	"./img/amazon.png": 3893,
	"./img/apple-music.png": 4766,
	"./img/bandcamp.png": 249,
	"./img/beatport.png": 6865,
	"./img/dc-logo.png": 3783,
	"./img/email-white.png": 7136,
	"./img/itunes.png": 1428,
	"./img/juno.png": 2150,
	"./img/pandora.png": 3781,
	"./img/share/DC024.jpg": 4033,
	"./img/soundcloud.png": 2413,
	"./img/spotify.png": 4749,
	"./img/tidal.png": 2255,
	"./img/traxsource.png": 4364,
	"./img/youtube.png": 4785,
	"./index": 8305,
	"./index.css": 1174,
	"./index.js": 8305,
	"./releases/DC004": 4561,
	"./releases/DC004.json": 4561,
	"./releases/DC006": 8769,
	"./releases/DC006.json": 8769,
	"./releases/DC010": 3001,
	"./releases/DC010.json": 3001,
	"./releases/DC011": 7489,
	"./releases/DC011.json": 7489,
	"./releases/DC012": 4617,
	"./releases/DC012.json": 4617,
	"./releases/DC013": 1307,
	"./releases/DC013.json": 1307,
	"./releases/DC014": 8556,
	"./releases/DC014.json": 8556,
	"./releases/DC018": 1777,
	"./releases/DC018.json": 1777,
	"./releases/DC021": 2910,
	"./releases/DC021.json": 2910,
	"./releases/DC022": 2144,
	"./releases/DC022.json": 2144,
	"./releases/DC024": 4693,
	"./releases/DC024.json": 4693,
	"./releases/DC025": 7934,
	"./releases/DC025.json": 7934,
	"./releases/SEN012": 4143,
	"./releases/SEN012.json": 4143,
	"./releases/uc008": 1534,
	"./releases/uc008.json": 1534,
	"./reportWebVitals": 4013,
	"./reportWebVitals.js": 4013,
	"./setupTests": 9511,
	"./setupTests.js": 9511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 407;